module.exports = __webpack_public_path__ + "img/success-academy-company.0f4499d3.png";